import { Box, Stack } from "@mui/material";
import { OrderConfirmCard } from "../components/Confirm";

import PaymentInfo from "../components/Payment/PaymentInfo";

export const PaymentConfirmPage = () => {
  return (
    <Box px={2} py={2} maxWidth={480}>
      <Stack spacing={1.5}>
        <OrderConfirmCard />
        <PaymentInfo />
      </Stack>
    </Box>
  );
};
